import React from 'react';
import { View, Text } from 'react-native';
import PropTypes from 'prop-types';
import s from '../../style/reRunRulesModal';

/**
 * Renders a single order's change preview (tags to add/remove, items, rules matched).
 * Pure presentational — no state, no side effects.
 */
const OrderChangeCard = ({ result }) => (
  <View key={result.order_id} style={s.orderCard}>
    <Text style={s.orderNumber}>{result.order_number || `Order #${result.order_id}`}</Text>

    {result.changes?.tags_to_add?.length > 0 && (
      <View style={s.changeRow}>
        <Text style={s.changeLabel}>Tags to add:</Text>
        <View style={s.chipContainer}>
          {result.changes.tags_to_add.map((tag) => (
            <View key={tag} style={s.greenChip}>
              <Text style={s.chipText}>{tag}</Text>
            </View>
          ))}
        </View>
      </View>
    )}

    {result.changes?.tags_to_remove?.length > 0 && (
      <View style={s.changeRow}>
        <Text style={s.changeLabel}>Tags to remove:</Text>
        <View style={s.chipContainer}>
          {result.changes.tags_to_remove.map((tag) => (
            <View key={tag} style={s.redChip}>
              <Text style={s.chipText}>{tag}</Text>
            </View>
          ))}
        </View>
      </View>
    )}

    {result.changes?.items_to_add?.length > 0 && (
      <View style={s.changeRow}>
        <Text style={s.changeLabel}>Items to add:</Text>
        {result.changes.items_to_add.map((item) => (
          <Text key={item.sku} style={s.itemText}>
            {item.sku} x{item.qty}{item.name ? ` — ${item.name}` : ''}
          </Text>
        ))}
      </View>
    )}

    {result.rules_matched?.length > 0 && (
      <View style={s.changeRow}>
        <Text style={s.changeLabel}>Rules matched:</Text>
        {result.rules_matched.map((rule) => (
          <Text key={rule.rule_id} style={s.ruleText}>"{rule.rule_name}"</Text>
        ))}
      </View>
    )}
  </View>
);

OrderChangeCard.propTypes = {
  result: PropTypes.object.isRequired,
};

export default OrderChangeCard;
